export interface PostTemplate {
    Id: number;
    Title: string;
    Description: string;
    Caption: string;
    ImageIds: string ;
    CreatedByUserId: string;
    DateCreatedutc: string;
}

export class CreatePostTemplate 
{
    Title: string;
    Description: string;
    Caption: string;
    ImageIds: string;
}

export class EditPostTemplate extends CreatePostTemplate {
    Id: number;

    constructor(item?: PostTemplate){
        super();
        this.Id = item.Id;
        this.Title = item.Title;
        this.Description = item.Description;
        this.Caption = item.Caption;
        this.ImageIds = item.ImageIds;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/PostTemplate.ts